import { useState } from 'react'

import { SupportProvider, useConfig } from '../context/config'

export enum PROFILE_VALIDATION_ERROR_CODES {
  EMAIL_CONFLICT = 'EMAIL_CONFLICT',
  PHONE_CONFLICT = 'PHONE_CONFLICT',
  CPF_GET_DATA_ERROR = 'CPF_GET_DATA_ERROR',
  CPF_DUPLICATED = 'CPF_DUPLICATED',
}

export function useCreateProfileValidation() {
  const { config } = useConfig()
  const [phoneNumberExists, setPhoneNumberExists] = useState(false)
  const [emailExists, setEmailExists] = useState(false)
  const [cpfExists, setCpfExists] = useState(false)

  function handleError(error: unknown) {
    if (error instanceof Error) {
      if (error.message === PROFILE_VALIDATION_ERROR_CODES.EMAIL_CONFLICT) {
        setEmailExists(true)
      }
      if (error.message === PROFILE_VALIDATION_ERROR_CODES.PHONE_CONFLICT) {
        setPhoneNumberExists(true)
      }
      if (error.message === PROFILE_VALIDATION_ERROR_CODES.CPF_GET_DATA_ERROR) {
        throw new Error(PROFILE_VALIDATION_ERROR_CODES.CPF_GET_DATA_ERROR)
      }
      if (error.message === PROFILE_VALIDATION_ERROR_CODES.CPF_DUPLICATED) {
        setCpfExists(true)
      }
    }

    if (config.partnerConfig?.supportProvider.type === SupportProvider.Zendesk) {
      throw new Error('Create profile error')
    }
  }

  return {
    cpfExists,
    emailExists,
    handleError,
    phoneNumberExists,
    setCpfExists,
    setEmailExists,
    setPhoneNumberExists,
  }
}
